/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./game-rules.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/common";
import * as i3 from "./game-rules.component";
import * as i4 from "../shared/translation.service";
import * as i5 from "@angular/platform-browser";
import * as i6 from "../shared/oe-app.service";
import * as i7 from "../shared/window.service";
var styles_GameRulesComponent = [i0.styles];
var RenderType_GameRulesComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_GameRulesComponent, data: {} });
export { RenderType_GameRulesComponent as RenderType_GameRulesComponent };
function View_GameRulesComponent_1(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "iframe", [], [[8, "src", 5]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.iframeUrl; _ck(_v, 0, 0, currVal_0); }); }
export function View_GameRulesComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵand(16777216, null, null, 1, null, View_GameRulesComponent_1)), i1.ɵdid(1, 16384, null, 0, i2.NgIf, [i1.ViewContainerRef, i1.TemplateRef], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.iframeUrl; _ck(_v, 1, 0, currVal_0); }, null); }
export function View_GameRulesComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-game-rules", [], null, null, null, View_GameRulesComponent_0, RenderType_GameRulesComponent)), i1.ɵdid(1, 114688, null, 0, i3.GameRulesComponent, [i4.TranslationService, i5.DomSanitizer, i6.OeAppService, i7.WindowService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var GameRulesComponentNgFactory = i1.ɵccf("lp2-game-rules", i3.GameRulesComponent, View_GameRulesComponent_Host_0, {}, {}, []);
export { GameRulesComponentNgFactory as GameRulesComponentNgFactory };
//# sourceMappingURL=game-rules.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/game-rules/game-rules.component.ngfactory.js
// module id = 1721
// module chunks = 27 28 29